'use strict';

var OfflineCalendarReviewGridController = function OfflineCalendarReviewGridController($rootScope, $scope, $q, dataRetrieverService, dataRetrieverConstantsService, SeasonCustomRenderer, seasonalityOverridesService) {
  var singleCalendarDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SEASONALITY_SCREEN, dataRetrieverConstantsService.SEASONALITY_ANALYSIS_CHART_HISTORICAL, dataRetrieverConstantsService.SEASONALITY_OFFLINE_CALENDAR_REVIEW);
  $scope.customRenderers = SeasonCustomRenderer;
  $scope.loadGrid = function () {
    updateDataRetriever();
    $scope.$broadcast('grid:loadData:' + $scope.gridId);
  };
  $scope.reloadIfNewCalendar = function (newMarketCalendar, oldMarketCalendar) {
    if (newMarketCalendar !== oldMarketCalendar) {
      $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
    } else {
      $scope.$broadcast('grid:dataAndSelectionChangedGrid:' + $scope.gridId);
    }
  };
  function updateDataRetriever() {
    var searchCriteriaDefer = $q.defer();
    singleCalendarDataRetriever.setCustomSearchCriteriaRules(searchCriteriaDefer.promise);
    searchCriteriaDefer.resolve(getRqlQuery());
  }
  function getRqlQuery() {
    return 'origin==' + $scope.displayedCalendar.origin + ';destination==' + $scope.displayedCalendar.destination + ';calendarName=="' + $scope.displayedCalendar.calendarName + '"';
  }
  $scope.onCellEditHandler = function (gridData, rowId) {
    if (gridData[rowId].season === '') return;
    $scope.displayedCalendar.overrides = seasonalityOverridesService.addOverride($scope.displayedCalendar, gridData[rowId].weekOfYear, gridData[rowId].season, gridData[rowId].classGroup, gridData[rowId].dowGroup, gridData[rowId].spos);
    $scope.$emit('seasonality-analysis:override-data-change', $scope.displayedCalendar.overrides);
  };
};
OfflineCalendarReviewGridController.$inject = ['$rootScope', '$scope', '$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'SeasonCustomRenderer', 'SeasonalityOverridesService'];
module.exports = OfflineCalendarReviewGridController;